module.exports = __webpack_public_path__ + "img/ico-linkedin.990ccd29.svg";